import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollapseModule } from 'ngx-bootstrap';
import { RouterModule } from '@angular/router';
import { AuthModule } from './auth/auth.module';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { titoPipe } from './navbar/custom.pipe';
import { SharedModule } from '../app/shared/shared.module';
import { MRFooterComponent } from '../components/mr-footer/mr.footer.component'
import { MRHeaderComponent } from '../components/mr-header/mr-header.component'

@NgModule({
    imports: [
        BrowserModule,
        CommonModule,
        CollapseModule,
        AuthModule,
        FormsModule, ReactiveFormsModule,
        RouterModule,
        SharedModule
    ],
    declarations: [
        NavbarComponent,
        FooterComponent,
        titoPipe,
        MRFooterComponent,
        MRHeaderComponent
    ],
    exports: [
        NavbarComponent,
        FooterComponent,
        MRFooterComponent,
        MRHeaderComponent

    ]
})
export class DirectivesModule { }
